import { Platform } from "react-native";
import { IStorage } from "./implementations/IStorage";
import NativeStorage from "./implementations/NativeStorage";
import WebStorage from "./implementations/WebStorage";

interface IOpt {
    isSecure?: boolean,
    oldKey?: string
}

export class Storage {
    private version = "2";
    static instance: Storage;
    private implementation: IStorage;

    constructor() {
        this.implementation = Platform.OS === 'web' ? new WebStorage() : new NativeStorage();
    }

    static getInstance() {
        if (!Storage.instance) {
            Storage.instance = new Storage();
        }
        return Storage.instance
    }

    getItem = async (key: string, options?: IOpt) => {
        const isSecure = !(options?.isSecure === false);
        const current = await this.implementation.getItem(`${key}_v${this.version}`, { isSecure });
        const old = await this.implementation.getItem(options?.oldKey || key, { isSecure });
        return current || old;
    }

    setItem = (key: string, item: any, options?: IOpt) => {
        const isSecure = !(options?.isSecure === false);
        return this.implementation.setItem(`${key}_v${this.version}`, item, { isSecure });
    }

    removeItem = (key: string, options?: IOpt) => {
        const isSecure = !(options?.isSecure === false);
        return this.implementation.removeItem(`${key}_v${this.version}`, { isSecure });
    }
}